@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ErrorPopOut {
  @extend %font-family-primary;

  border-radius: 6px;
  background: $color-alert-red-background;
}
